import React, { useEffect, useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
import { LogoIcon } from './LogoIcon';
import { CtaLink } from './CtaLink';
import { navLinks, cloudLink } from '../data/siteLinks';
export function Navigation() {
  const [isOpen, setIsOpen] = useState(false);
  useEffect(() => {
    if (!isOpen) return;
    const onKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') setIsOpen(false);
    };
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [isOpen]);
  const close = () => setIsOpen(false);
  return <header className="fixed top-0 left-0 right-0 z-50 bg-white/90 backdrop-blur-xl border-b border-gray-100" data-id="element-390" data-mp="jzydffxo7s9r">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-391" data-mp="f1wtytwc1qxr">
        <div className="flex justify-between items-center h-16" data-id="element-392" data-mp="t03j9ln7uilt">
          <a href="#top" className="flex items-center gap-3 min-h-[44px] rounded-lg" aria-label="nexify-studio.tech — na začiatok stránky" data-id="element-393" data-mp="syacm6clrydt">
            <LogoIcon size={36} data-id="element-394" data-mp="dhil78yddgjw" />
            <span className="text-lg font-bold tracking-tight text-apple-black hidden sm:inline" data-id="element-395" data-mp="hhb003ecwixp">
              nexify-studio.tech
            </span>
          </a>

          <nav aria-label="Hlavná navigácia" className="hidden lg:flex items-center gap-7" data-id="element-396" data-mp="mf2o0mbvrkwm">
            {navLinks.map(link => <a key={link.href} href={link.href} className="text-sm font-medium text-apple-black hover:text-apple-blue transition-colors duration-200 py-2" data-id="element-397" data-mp="wejrcx3ntmpf">
                {link.label}
              </a>)}
            <a href={cloudLink.href} target="_blank" rel="noopener noreferrer" className="text-sm font-semibold text-apple-blue hover:text-apple-blueHover transition-colors duration-200 py-2" data-id="element-398" data-mp="158yetmycg3jm">
              {cloudLink.label}
              <span className="sr-only" data-id="element-399" data-mp="1k21qjdp97n2f"> (otvorí sa v novom okne)</span>
            </a>
          </nav>

          <div className="hidden lg:flex items-center" data-id="element-400" data-mp="udw6c2w67iib">
            <CtaLink href="#kontakt" size="medium" data-id="element-401" data-mp="phyry24gwm86">
              Začať projekt
            </CtaLink>
          </div>

          <button type="button" onClick={() => setIsOpen(v => !v)} className="lg:hidden w-11 h-11 flex items-center justify-center rounded-lg text-apple-black hover:bg-gray-100 transition-colors" aria-label={isOpen ? 'Zavrieť menu' : 'Otvoriť menu'} aria-expanded={isOpen} aria-controls="mobilne-menu" data-id="element-402" data-mp="147d1ba81n3nk">
            {isOpen ? <XIcon className="w-6 h-6" data-id="element-403" data-mp="1n45xpfcickm4" /> : <MenuIcon className="w-6 h-6" data-id="element-404" data-mp="1n2bm4rn4m4up" />}
          </button>
        </div>
      </div>

      <div id="mobilne-menu" className={`lg:hidden overflow-hidden transition-[max-height] duration-300 ease-in-out bg-white ${isOpen ? 'max-h-[32rem] visible border-b border-gray-100' : 'max-h-0 invisible'}`} data-id="element-405" data-mp="1i3i54p8mrvps">
        <nav aria-label="Mobilná navigácia" className="flex flex-col px-4 pt-2 pb-6 gap-1" data-id="element-406" data-mp="1zfyiq00554dc">
          {navLinks.map(link => <a key={link.href} href={link.href} onClick={close} className="flex items-center min-h-[48px] px-4 text-base font-medium text-apple-black hover:bg-gray-50 rounded-lg transition-colors" data-id="element-407" data-mp="24d7223x0zeg6">
              {link.label}
            </a>)}
          <a href={cloudLink.href} target="_blank" rel="noopener noreferrer" onClick={close} className="flex items-center min-h-[48px] px-4 text-base font-semibold text-apple-blue hover:bg-blue-50 rounded-lg transition-colors" data-id="element-408" data-mp="1gqs8709i3j2m">
            {cloudLink.label}
            <span className="sr-only" data-id="element-409" data-mp="313r4v8jxbz68"> (otvorí sa v novom okne)</span>
          </a>
          <div className="px-4 pt-4" data-id="element-410" data-mp="3633ug126jkci">
            <CtaLink href="#kontakt" onClick={close} className="w-full" data-id="element-411" data-mp="36214pwglfny6">
              Začať projekt
            </CtaLink>
          </div>
        </nav>
      </div>
    </header>;
}